type CirclePickState = {
  active: boolean;
  expectedBodies: string[];
};

let state: CirclePickState = {
  active: false,
  expectedBodies: [],
};

export function getCirclePickState(): CirclePickState {
  return state;
}

export function activateCirclePick(expectedBodies: unknown) {
  const bodies = Array.isArray(expectedBodies)
    ? expectedBodies.map((v) => String(v || "").trim()).filter(Boolean)
    : [];
  state = {
    active: true,
    expectedBodies: bodies,
  };
}

export function deactivateCirclePick() {
  state = {
    ...state,
    active: false,
  };
}
